import React, { useContext } from "react";
import { motion, MotionValue, useTransform } from "framer-motion";
import { SiteContext } from "../../../../Contexts/SiteContext";

export function useParallax(value: MotionValue<number>, distance: number) {
	return useTransform(value, [0, 1], [`${-distance}%`, `${distance}%`]);
}

export function useOpacity(value: MotionValue<number>) {
	return useTransform(value, [0.7, 1], [0.9, 1]);
}

export function useContainerOpacity(value: MotionValue<number>) {
	return useTransform(value, [0, 1], [0, 1]);
}


const Bikes = ({ scrollYProgress }: { scrollYProgress: MotionValue<number> }) => {
	const { deviceType } = useContext(SiteContext);

	const y1 = useParallax(scrollYProgress, deviceType === "desktop" ? 10 : 30);
	const y2 = useParallax(scrollYProgress, deviceType === "desktop" ? 2 : 15);

	// const opacity = useOpacity(scrollYProgress);

	return (
		<motion.div
			className="bikes-wrapper"
			transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
			whileInView={{ opacity: 1 }}
			initial={{ opacity: 0 }}
			viewport={{ amount: "all", margin: "300px" }}
		>
			<div className="bikes">
				<motion.img
					style={{ x: y1 }}
					key="bike-1"
					className="bike bike1"
					width="500"
					src="/roadsync/at_model.png"
					alt="AT Model"
				// initial={{ opacity: 0 }}
				// whileInView={{ opacity: 1 }}
				/>

				<motion.img
					style={{ x: y2 }}
					key="bike-2"
					className="bike bike2"
					width="500"
					src="/roadsync/hornet_model.png"
					alt="Hornet Model"
				// initial={{ opacity: 0 }}
				// whileInView={{ opacity: 1 }}
				/>
			</div>
		</motion.div>
	);
}

export default Bikes;
